import { combineReducers } from '@reduxjs/toolkit';
import authSlice from './Slices/Auth/authSlice';
import catSlice from './Slices/Category/catSlice';
import testSlice from './Slices/Testimonial/testSlice';
import brandSlice from './Slices/Brand/brandSlice';
import homepageSlice from './Slices/Page/homepageSlice';
import aboutuspageSlice from './Slices/Page/aboutuspageSlice';
import showcaseSlice from './Slices/Freelancer/showcaseSlice';
import profileSlice from './Slices/Common/profileSlice';
import skilSlice from './Slices/Category/skilSlice';
import settingSlice from './Slices/Common/settingSlice';
import headSlice from './Slices/Home/headSlice';
import quickeasy1Slice from './Slices/Quickeasy/quickeasy1Slice';
import quickeasy2Slice from './Slices/Quickeasy/quickeasy2Slice';
import businessSlice from "./Slices/Businesshightlights/businessSlice";
import freelancedashboardSlice from "./Slices/Freelancer/freelancedashboardSlice";
import projectpostSlice from "./Slices/Client/projectpostSlice";
import jobdetailsSlice from "./Slices/Freelancer/jobdetailsSlice";
import placeBidSlice from './Slices/Freelancer/placebidSlice';
import dashboardbannerSlice from './Slices/Common/dashboardbannerSlice';
import walletSlice from './Slices/Wallet/walletSlice';
import curencyOpSlice from './Slices/Category/curencyOpSlice';
import clientDashboardSlice from './Slices/Client/clientDashboardSlice';
import proposalSlice from './Slices/Client/proposalSlice';
import supportSlice from './Slices/Common/supportSlice';
import freelancerProposalSlice from './Slices/Freelancer/freelancerProposalSlice';
import freelancerSlice from './Slices/Client/freelancerSlice';
import chatSlice from './Slices/Common/chatSlice';
import showcaseClientSlice from './Slices/Client/showcaseClientSlice';
import showcasePaymentSlice from './Slices/Client/showcasePaymentSlice';
import milestoneSlice from './Slices/Common/milestoneSlice';
import freelancerOrderSlice from './Slices/Freelancer/freelancerOrderSlice';
import showcaseOrderSlice from './Slices/Common/showcaseOrderSlice';
import reviewSlice from './Slices/Common/reviewSlice';
import notificationSlice from './Slices/Common/notificationSlice';
import disputeSlice from './Slices/Common/disputeSice';
import supportfaqSlice from './Slices/Common/supportfaqSlice';
import certificationSlice from './Slices/Common/certificationSlice';
import pageSlice from './Slices/Page/pageSlice';
import searchSlice from './Slices/Common/searchSlice';
import ClientCollectionsSlice from './Slices/Common/freelancerSlice'
// freenlancerHiresSlice

const rootReducer = combineReducers({
    auth: authSlice,
    cat: catSlice,
    test: testSlice,
    businesshighlights: businessSlice,
    brand: brandSlice,
    quickeasy1: quickeasy1Slice,
    quickeasy2: quickeasy2Slice,
    showcase: showcaseSlice,
    profile: profileSlice,
    skil: skilSlice,
    page: pageSlice,
    homepage: homepageSlice,
    aboutuspage: aboutuspageSlice,
    settings: settingSlice,
    head: headSlice,
    freelancedashboard: freelancedashboardSlice,
    projectpost: projectpostSlice,
    jobdetails: jobdetailsSlice,
    placeBid: placeBidSlice,
    dashboardbanner: dashboardbannerSlice,
    wallet: walletSlice,
    currencyOp: curencyOpSlice,
    clientDashboard: clientDashboardSlice,
    proposal: proposalSlice,
    support: supportSlice,
    freelanceProposal: freelancerProposalSlice,
    empFreelancer: freelancerSlice,
    chat: chatSlice,
    showcaseClient: showcaseClientSlice,
    showcasePayment: showcasePaymentSlice,
    mile: milestoneSlice,
    freeOrder: freelancerOrderSlice,
    showOrder: showcaseOrderSlice,
    review: reviewSlice,
    noti: notificationSlice,
    dispute: disputeSlice,
    supportfaq: supportfaqSlice,
    certificate: certificationSlice,
    search: searchSlice,
    clientActivities:ClientCollectionsSlice
    
});

export default rootReducer;